import type * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetRolesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.RoleFilterInput>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  order?: Types.InputMaybe<Array<Types.RoleSortInput> | Types.RoleSortInput>;
}>;


export type GetRolesQuery = { roles?: Maybe<{ __typename?: 'RoleCollectionSegment', totalCount: number, items?: Maybe<Array<{ __typename?: 'Role', id: string, name: string, description?: Maybe<string>, mappingRoleUsers: Array<{ __typename?: 'MappingRoleUser', id: string, user: { __typename?: 'User', id: string, userName: string } }>, mappingRoleScopes: Array<{ __typename?: 'MappingRoleScope', id: string, scope: { __typename?: 'Scope', id: string, name: string } }> }>> }> };


export const GetRolesDocument = gql`
    query getRoles($where: RoleFilterInput, $take: Int, $skip: Int, $order: [RoleSortInput!]) {
  roles(where: $where, take: $take, skip: $skip, order: $order) {
    totalCount
    items {
      id
      name
      description
      mappingRoleUsers(where: {isDeleted: {neq: true}}) {
        id
        user {
          id
          userName
        }
      }
      mappingRoleScopes(where: {isDeleted: {neq: true}}) {
        id
        scope {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
export type Maybe<T> = Types.Maybe<T>;
